"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Flag = function Flag(props) {
  var outerflag = props.outerflag,
      innerflag = props.innerflag;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.01216,1.00145H16.76109L13.58557,6.119l3.17552,5.05556H1.01216Z",
    fill: "#ffffff",
    className: innerflag
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.76411,6.11594,17.61079,1.529A.99976.99976,0,0,0,16.76118.00168H1.01216a.99942.99942,0,0,0-1,1V22.9968a1,1,0,0,0,2,0V12.17454h14.749a1.0004,1.0004,0,0,0,.84668-1.53223Zm-12.752,4.0586V2.00168H14.96333L12.73579,5.59153a1.00146,1.00146,0,0,0,.00293,1.05957l2.21289,3.52344Z",
    fill: "#004864",
    className: outerflag
  }));
};

var _default = Flag;
exports["default"] = _default;